import { render, staticRenderFns } from "./doc-pindaan-harta_alih.vue?vue&type=template&id=6454a8f1&"
import script from "./doc-pindaan-harta_alih.vue?vue&type=script&lang=js&"
export * from "./doc-pindaan-harta_alih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports